import React from "react";

const TableYearlySale = ({ yearlySalesData, isClient = false }) => {
  return (
    <table className="table">
      <thead className="table-head">
        <tr>
          <th>Year</th>
          {isClient && <th>This Client</th>}
          <th>All Sales</th>
        </tr>
      </thead>
      <tbody className="table-body">
        {yearlySalesData && yearlySalesData.length > 0 ? (
          yearlySalesData.map((item) => (
            <tr key={item?.year}>
              <td>{item?.year}</td>
              {isClient && <td>{item?.clientPurchaseThisYear}</td>}

              <td>{item?.totalSale}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="3" style={{ textAlign: "center" }}>
              No sales data available.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default TableYearlySale;
